/**
 * Short label for a file type, keyed by the backend `FileType` wire value —
 * never the store slice's "tb"/"gl" shorthand, which does not reach these
 * components.
 *
 * The file type alone, with no period basis: an MTD/YTD dimension only becomes
 * real once the GL year-to-date view exists, and labelling these "GL (MTD)" now
 * would promise a choice that cannot be made yet. They gain that suffix when the
 * toggle they describe ships.
 *
 * Shared by the submission navigation and the Submission history table so a
 * relabelling cannot leave one of them behind.
 */
const FILE_TYPE_LABELS: Record<string, string> = {
    trial_balance: "TB",
    general_ledger: "GL",
    open_trial_balance: "OTB",
    financial_journals: "FJ",
    tb_gl: "TB/GL",
};

export function fileTypeLabel(fileType: string): string {
    return FILE_TYPE_LABELS[fileType] ?? fileType.toUpperCase();
}
